/**
 * Fathead  Configuration
 * Centralized configuration for the  integration
 */
window.FATHEAD_CONFIG = {
   //Url: 'https://22e3-47-149-176-198.ngrok-free.app',
   Url: 'https://fathead-.vercel.app',
  allowedOrigins: [
    'https://fathead-.vercel.app',
    'https://fathead.com',
    'https://22e3-47-149-176-198.ngrok-free.app',
    'null' // Allow null origin during development
  ]
};